import axios from 'axios';
import get from 'lodash/get';

//! PLOP_APPEND_SERVICE

export async function isUserDeservedForGift() {
  return axios
    .get(`/user-products/v1/is-deserve-a-gift`)
    .then((res) => res.data);
  // your logic here
}

export async function reserveProductToUser({
  userId,
  productId,
  answers,
  type,
}) {
  if (type === 'rent' || type === 'sg_services' || type === 'event') {
    return axios
      .post(`/user-products/v1/regular`, { userId, productId, answers, type })
      .then((res) => res.data);
  }
  return axios
    .post(`/user-products/v1/gift`, { userId, productId, answers })
    .then((res) => res.data);
}

export async function getProductById(id) {
  // your logic here
  return axios.get(`/products/v1/${id}`).then((res) => res.data);
}

export async function getAllProducts() {
  return axios.get('/products/v1').then((res) => res.data);
  // your logic here
}

export async function isUserAlreadyOrdered(productId) {
  return axios.get(
    `/user-products/v1/is-deserve-the-product?productId=${productId}`
  );
}
